import MainLookupDialog from 'src/components/LookupDialogs/MainLookupDialog.vue';
import appendComponentToBody from './appendComponentToBody';
export default function openMainLookupDialog(props) {
    const dialog = appendComponentToBody({
        component: MainLookupDialog,
        componentProps: props
    });
    dialog.open(props);
    return dialog;
}
